export enum ErrorMessages {
  DEFAULT = '',
  LOADING_TODOS = 'Unable to load todos',
  EMPTY_TITLE = 'Title should not be empty',
  ADDING_TODO = 'Unable to add a todo',
  DELETING_TODO = 'Unable to delete a todo',
  UPDATING_TODO = 'Unable to update a todo',
}
